/* eslint-disable @typescript-eslint/no-explicit-any */
import type { CustomerApi } from '@/types/customer'
import type { Subscription } from '@/types/authAccs'
import { wrapGqlRequest } from '@/services/graphqlEndPointCommonSetting/wrapGqlRequest'

export const useCustomerAccsService = () => {
    const doFetchCustomer = async (): Promise<{
        data: Ref<CustomerApi | undefined>
        error: Ref<Error | null>
    }> => {
        const data = ref<CustomerApi>()
        const error = ref<Error | null>(null)
        const query = `query GetCustomerProfile {
    customer {
      id
      firstname
      lastname
      email
    }
  }`
        try {
            // Call GraphQL API to fetch customer profile
            const result = await wrapGqlRequest(query, {}, 'customer')
            // Assign GraphQL response to data ref
            data.value = result
        } catch (err: any) {
            // Assign error if request fails
            error.value = err
        }

        // Return same structure as old REST useApiFetch
        return {
            data,
            error,
        }
    }

    const doUpdateSubscription = async (
        payload: Subscription
    ): Promise<{
        data: Ref<unknown | undefined>
        error: Ref<Error | null>
    }> => {
        const data = ref<unknown>()
        const error = ref<Error | null>(null)

        try {
            // Call only if subscribe = true
            if (!payload.subscribe) {
                return { data, error }
            }

            const updateCustomerMutation = `
            mutation UpdateCustomer {
                updateCustomerV2(input: {
                    is_subscribed: true
                }) {
                    customer {
                        email
                        firstname
                        lastname
                        is_subscribed
                        id
                    }
                }
            }
        `
            const res = await wrapGqlRequest(updateCustomerMutation, {}, 'updateCustomerV2')
            data.value = res?.customer
        } catch (err) {
            error.value = err as Error
        }
        return {
            data,
            error,
        }
    }
    return {
        doFetchCustomer,
        doUpdateSubscription,
    }
}
